(function ($) {

    'use strict';



    const $carousel = $('#single-wheel-carousel');

    if (!$carousel.length || typeof $.fn.slick !== 'function') {

        return;

    }



    const singleWheelCarouselSelf = $carousel.slick({

        autoplay: true,

        speed: 600,

        slidesToShow: 4,

        slidesToScroll: 1,

        autoplaySpeed: 99999999,

        swipeToSlide: true,

        responsive: [

            {

                breakpoint: 1025,

                settings: {

                    slidesToShow: 3,

                }

            },

            {

                breakpoint: 768,

                settings: {

                    slidesToShow: 2,

                }

            },

            {

                breakpoint: 501,

                settings: {

                    slidesToShow: 1,

                }

            },

        ]

    });



    if (typeof window.fixingSlickCarousel === 'function') {

        window.fixingSlickCarousel(singleWheelCarouselSelf);

    }

})(jQuery);

